import { ENDPOINTS } from '../consts/endpoints';
import { DEFAULT_PARAMS } from '../../user-api';
import { AbstractApi } from '../../abstract-api';
import { GetRoleDepartmentsRespBody } from '../schema';
import { RoleProfile, RoleDepartment, RoleProfileParams, RoleProfileResponse } from '../types';

export class RoleApi extends AbstractApi {
  async getProfiles(userType?: string): Promise<RoleProfile[]> {
    const axios = await this.axios();
    const params: RoleProfileParams = {
      userType: userType ?? DEFAULT_PARAMS.USER_TYPE,
    };
    const { data } = await axios.get<RoleProfileResponse>(ENDPOINTS.LEARNING.ROLE.PROFILE, {
      params,
    });
    return data.profiles;
  }

  async getDepartments(): Promise<RoleDepartment[]> {
    const axios = await this.axios();
    const { data } = await axios.get<GetRoleDepartmentsRespBody>(
      ENDPOINTS.LEARNING.ROLE.DEPARTMENTS
    );
    return data.roleDepartments;
  }

  async getManageProfiles(userType?: string): Promise<RoleProfile[]> {
    const axios = await this.axios();
    const params: RoleProfileParams = {
      userType: userType ?? DEFAULT_PARAMS.USER_TYPE,
    };
    const { data } = await axios.get<RoleProfileResponse>(ENDPOINTS.LEARNING.MANAGE.ROLE_PROFILE, {
      params,
    });
    return data.profiles;
  }
}
